import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between text-base font-[500] text-dark-gray px-1" }
const _hoisted_3 = { class: "h-[20px] w-full rounded-3xl bg-light-gray overflow-hidden" }

interface Props {
    label: string
    percent: number
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    label: null,
    percent: null
  },
  setup(__props: any) {

const props = __props as {
    label: string
    percent: number
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(props.label), 1),
      _createElementVNode("span", null, _toDisplayString(props.percent) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "bg-primary-violet w-full h-full",
        style: _normalizeStyle({ width: `${props.percent}%` })
      }, null, 4)
    ])
  ]))
}
}

})